import {useLayoutEffect} from 'react';

/**
 * Custom hook to scroll to the top of the page when the component mounts or dependencies change.
 * @param {Array} dependencies - Optional array of dependencies that trigger the scroll effect.
 */
const useScrollToTop = (dependencies: any[] = []) => {
  useLayoutEffect(() => {
    // Scroll to the top of the page
    requestAnimationFrame(() => {
      window.scrollTo({left: 0, top: 0, behavior: 'smooth' });
    });
    // allows dynamic dependencies to trigger the effect
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);
};

export default useScrollToTop;